import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const FAQSection = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const faqs = [
    {
      questionKey: "faq.q1.question",
      answerKey: "faq.q1.answer"
    },
    {
      questionKey: "faq.q2.question",
      answerKey: "faq.q2.answer"
    },
    {
      questionKey: "faq.q3.question",
      answerKey: "faq.q3.answer"
    },
    {
      questionKey: "faq.q4.question",
      answerKey: "faq.q4.answer"
    },
    {
      questionKey: "faq.q5.question",
      answerKey: "faq.q5.answer"
    }
  ];

  return (
    <section className="bg-white py-20 px-6 border-t">
      <div className="max-w-4xl mx-auto">
        <motion.h2
          className="text-3xl font-bold text-gray-900 text-center mb-4"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {t("faq.title")}
        </motion.h2>
        <motion.p
          className="text-center text-gray-600 mb-12"
          initial={{ opacity: 0, y: -10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.2 }}
        >
          {t("faq.subtitle")}
        </motion.p>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex justify-between items-center px-4 py-4 text-left text-gray-800 font-medium hover:bg-gray-50"
              >
                {t(faq.questionKey)}
                {openIndex === i ? (
                  <FiChevronUp className="text-primary" />
                ) : (
                  <FiChevronDown className="text-gray-500" />
                )}
              </button>

              <AnimatePresence>
                {openIndex === i && (
                  <motion.div
                    className="px-4 pb-4 text-sm text-gray-600"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    {t(faq.answerKey)}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
